import { Box, Carousel, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

import ImagesSlider from "../images-slider"

import LandingProduct from "./landing-product/landing-product"

const LandingHorizontalProducts = ({ element, lazyload }) => (
  <>
    <MediaBox greaterThanOrEqual="tablet" id={element.anchor_name} mx={4}>
      <Box contain mx="auto">
        <ImagesSlider
          arrowAdjust="50px"
          arrowPlacement="outside"
          slidesToShow={4}
        >
          {element.products.map((product, index) => {
            return (
              <LandingProduct
                align="horizontal"
                element={element}
                index={index}
                key={index}
                lazyload={lazyload}
                product={product}
                product_defaults={element.product_defaults}
                show_prices={!!element.show_prices}
              />
            )
          })}
        </ImagesSlider>
      </Box>
    </MediaBox>
    <MediaBox id={element.anchor_name} lessThan="tablet" ml={1}>
      <Carousel displayArrows="none">
        {element.products.map((product, index) => {
          return (
            <LandingProduct
              align="horizontal"
              imageContainerStyle={{ width: "34vw" }}
              index={index}
              key={index}
              lazyload={lazyload}
              product={product}
              product_defaults={element.product_defaults}
              show_prices={!!element.show_prices}
            />
          )
        })}
      </Carousel>
    </MediaBox>
  </>
)

LandingHorizontalProducts.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingHorizontalProducts
